import React from 'react'

export default function RenderSection({ classNames, children, ...props }) {
    return (
        <section {...props} className={`p-5 rounded-[10px] bg-[#F3F4F6] ${classNames || ''}`}>
            {children}
        </section>
    )
}
